<template>

    <form ref="instituicaoensinomodalidade-form-create" v-on:submit.prevent="executeCreate(model)" novalidate>

        <div class="row">

            <div class="form-group col-md-12">
                <label for="modalidadeId">Modalidade</label>
                <select v-select="{ dataitem: 'Modalidade', default: 'Selecione' }" v-model="model.modalidadeId" class="form-control" name="modalidadeId" required></select>
            </div>

        </div>

        <button type="button" class="btn btn-default" @click="onBack()">
            <span>Voltar</span>
        </button>
        <button type="button" class="btn btn-success float-right" @click="executeCreate(model)">
            <span>Salvar</span>
        </button>

    </form>


</template>
<script>
    
	import base from '@/common/base.js'
    import { Api } from '@/common/api'

    export default {
        name: "instituicaoensinomodalidade-form-create",
        mixins: [base],
        props: { id: Number },
        data: () => ({

            model: {},

            form: "instituicaoensinomodalidade-form-create",
            
            resources: {
                create: 'instituicaoensinomodalidade',
            },

        }),
		
        methods: {

            executeCreate: function (model) {

                if (this.formValidate() == false)
                    return;

                this.model.instituicaoEnsinoId = this.$props.id;
                new Api(this.resources.create).post(model).then(data => {
                    this.$emit('on-saved', data)
                    this.defaultSuccessResult('Registro inserido com sucesso');
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            formValidate: function () {
                var $form = this.$refs[this.form];
                $form.classList.add("was-validated");
                return $form.checkValidity();
            },

            onBack: function () {
                this.$emit('on-back')
            }
        },
    };
</script>

